"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const surface_styles_1 = require("@/components/common/surface/surface.styles");
require("@/components/common");
/**
 * 페이지 흐름 사이에서 다음 행동 하나로 이끄는 배너. 가운데 정렬한 제목·설명과 버튼을 채운 표면에 담는다.
 * 버튼은 action 슬롯으로 받아 동작을 소비자가 정한다.
 * variant="primary"는 주변 콘텐츠 사이에서 눈에 띄어야 하는 자리에 브랜드 색을 옅게 깐 면을 쓴다.
 */
let Banner = class Banner extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = '';
        this.description = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-text-block
        level="2"
        centered
        heading=${this.heading}
        description=${this.description}
      ></mm-text-block>
      <slot name="action"></slot>
    `;
    }
};
Banner.styles = (0, lit_1.css) `
    :host {
      ${surface_styles_1.surfaceBaseStyles};
      --surface-padding: var(--space-16) var(--space-6);
      --surface-border: var(--border-transparent);
      --surface-border-radius: var(--radius-large);
      --surface-background-color: var(--background-subtle-color);

      justify-content: center;
      align-items: center;
      gap: var(--space-6);
    }

    :host([variant='primary']) {
      --surface-background-color: var(--primary-subtle-color);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Banner.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Banner.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Banner.prototype, "description", void 0);
Banner = __decorate([
    (0, decorators_js_1.customElement)('mm-banner')
], Banner);
exports.Banner = Banner;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFubmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYmFubmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0QsK0VBQThFO0FBQzlFLCtCQUE0QjtBQUU1Qjs7OztHQUlHO0FBRUksSUFBTSxNQUFNLEdBQVosTUFBTSxNQUFPLFNBQVEsZ0JBQVU7SUFBL0I7O1FBbUJ1QixZQUFPLEdBQUcsRUFBRSxDQUFBO1FBQ1osZ0JBQVcsR0FBRyxFQUFFLENBQUE7SUFhOUMsQ0FBQztJQVhDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7O2tCQUlHLElBQUksQ0FBQyxPQUFPO3NCQUNSLElBQUksQ0FBQyxXQUFXOzs7S0FHakMsQ0FBQTtJQUNILENBQUM7O0FBL0JNLGFBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7UUFFYixrQ0FBaUI7Ozs7Ozs7Ozs7Ozs7O0dBY3RCLENBQUE7QUFDMEM7SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7dUNBQW9CO0FBQ2xDO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzt1Q0FBYTtBQUNaO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzsyQ0FBaUI7QUFwQmpDLE1BQU07SUFEbEIsSUFBQSw2QkFBYSxFQUFDLFdBQVcsQ0FBQztHQUNkLE1BQU0sQ0FpQ2xCO0FBakNZLHdCQUFNIn0=